import React,{useState} from "react";

import { OldBanijiya } from "./OldBanijiya";
import NewBanijiya from "./NewBanijiya";
import BackButton from "../../../../../components/common/backbutton/BackButton";

const BanijyaRenewal = () => {
  const [turnOn, setTurnOn] = useState(true)


  return (
    <div className="px-10 lg:!px-14">
      {/* <form className="px-2"> */}
        <p className="text-primary-red font-Rakkas my-7 text-center  font-semibold tracking-wide underline md:!text-3xl">
          Banijya Renewals
        </p>
        <div className="flex justify-between">
          <div className=" flex space-x-6 text-primary-red text-base font-bold sm:text-lg">
            <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
              <label htmlFor="old">पहिले नै हामीसंग आवद्ध भएको कम्पनी</label>
              <input type="radio" name="radio-btn" id="old" 
              onChange={()=> setTurnOn(true)}
              />
            </div>
            <div className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
              <label htmlFor="new">नयाँ कम्पनी </label>
              <input type="radio" name="radio-btn" id="new"
              onChange={()=> setTurnOn(false)}
              />
            </div>
          </div>
          <div className="text-primary-red flex items-center">
            Firm No.
            <p className=" text-primary-blue"> 1234</p>
          </div>
        </div>
        <div className="flex justify-between my-5">
          <p className="text-primary-blue font-Calistoga text-lg underline">
            1. Business Name & Other Details
          </p>
        </div>

    { 
    turnOn ?
    <OldBanijiya/>: <NewBanijiya/>}

       
    </div>
  );
};

export default BanijyaRenewal;
